export const EVENT_NAME = 'analyticsEvent';
